import React, { lazy, Suspense } from 'react';
import {connect} from "react-redux";
import {ErrorBoundary} from "react-error-boundary";
import {CONFIG} from "../../../app/config";
import {logError} from "../../core";

import Header from '../../../app/components/component.header';
import Footer from '../../../app/components/component.footer';
import Loader from "../../../app/components/component.loader";

import ComponentError from "../../../app/components/component.error";


const AdminBar = lazy(() => import("./component.admin-bar"));
const DevPanel = lazy(() => import("../dev/component.dev-panel"));
const Preview = lazy(() => import("./component.preview"));

const ComponentCookie = lazy(() => import("./component.cookie"));

const Page = lazy(() => import("./component.page"));

const isProduction = process.env.NODE_ENV === 'production';

const Main = (props) => {


    let svgCss;

    if(props.pageState.page?.template){

    }

    return <>
        <ErrorBoundary FallbackComponent={(error, reset) => { return <ComponentError error={error} reset={reset} />}} onError={(error) =>  { logError('page_render', error.message) }}>
            <Header />


            <main className={props.pageState.page?.template}>

                <div id="smooth-wrapper">
                    <div id="smooth-content">

                    {props.pageState.page &&
                    <Suspense fallback={<Loader/>}>
                        <Page />
                    </Suspense>}
                    {!props.pageState.page && <Loader/>}

                        <div className="svgouter" data-speed="clamp(0.75)"></div>
                        <svg preserveAspectRatio="xMidYMid slice" viewBox="0 0 400 400" className=""  data-speed="clamp(0.75)">

                            <path className="out-top" d="M718.3,316.4c0,157.9-117.3,212.1-267.1,244.7-158,34.4-333-87.4-319.2-244.7C142.4,198.6,266.5-1,425.1,30.4c165.5,32.9,293.1,128,293.1,285.9Z"/>
                            <path className="out-top2" d="M622.3,327.5c-8.9,106.9-91.4,137-194.7,150.6-108.9,14.4-220.5-78-202.3-183.7,13.7-79.2,109-207.3,214.6-177.1,110.2,31.6,191.2,103.2,182.3,210.1Z"/>
                            <path className="out-top3" d="M622.3,327.5c-8.9,106.9-91.4,137-194.7,150.6-108.9,14.4-220.5-78-202.3-183.7,13.7-79.2,109-207.3,214.6-177.1,110.2,31.6,191.2,103.2,182.3,210.1Z"/>
                        </svg>



                        <Footer />
                    </div>
                </div>



            </main>

        </ErrorBoundary>
        {props.authState.data &&
        <Suspense fallback={<span>Loading...</span>}>
            <AdminBar />
            <Preview />
        </Suspense>}
        {!isProduction &&
        <Suspense fallback={<span>Loading...</span>}>
            <DevPanel />
        </Suspense>}
        {CONFIG.components?.cookie_bar &&
        <Suspense fallback={<span>Loading...</span>}>
            <ComponentCookie {...CONFIG.components.cookie_bar} />
        </Suspense>}


    </>
};

export default connect(state => {
    return {
        authState: state.authState,
        pageState: state.pageState
    }
})(Main);
